import React from 'react';
import './Footer.css';
import scrollGif from './images/scrollformore.gif';

function Footer() {
    return (
        <footer className="footer">
            <img src={scrollGif} loading="lazy" alt="Scroll to find out more about Staflyapp" className="ScrollToFind" height="1024" width="1024"  />
        </footer>
    );
}

export default Footer;